export const fileGroups = {
  editableDoc: "editableDoc",
  general: "general",
  pdf: "pdf",
};

export const fileGroupConfig = {
  editableDoc:
    "application/vnd.oasis.opendocument.text,application/rtf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  general: "application/pdf,image/jpeg",
  pdf: "application/pdf",
};
